/** Anonymous-readable API paths — 401 must not trigger session logout redirect. */
export function isPublicApiRequestPath(path: string): boolean {
  if (path.includes('/api/reels/feed')) return true;
  if (path.includes('/api/reels/by-listing/')) return true;
  if (path.includes('/api/listing/active')) return true;
  if (/^\/api\/listing\/?$/.test(path)) return true;
  if (/^\/api\/listing\/[0-9a-f-]{36}$/i.test(path)) return true;
  if (/^\/api\/listing\/[0-9a-f-]{36}\/increment-view$/i.test(path)) return true;
  if (/^\/api\/analyticsevents\//i.test(path)) return true;
  return false;
}

export function isPublicApiRequestUrl(url: string | undefined): boolean {
  if (typeof url !== 'string') return false;
  const path = url.split('?')[0];
  return isPublicApiRequestPath(path);
}
